import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { FormComponent, UiComponent } from 'components';
import { UserGroupQuery } from 'queries';
import useModal from 'hooks/useModal';
import { USER_MENU_URL } from 'data/menu';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { IUserGroupCandidate } from 'types';
import Picker from '../Picker';
import * as UserGroupStyle from '../style';

const USER_GROUP_URL = USER_MENU_URL['회원 그룹 관리'];

function Register() {
  const navigate = useNavigate();
  const { handleConfirm, handleAlert } = useModal();
  const { mutateAsync: create, isPending } = UserGroupQuery.useCreate();
  const [name, setName] = useState('');
  const [selected, setSelected] = useState<IUserGroupCandidate[]>([]);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      handleAlert('그룹명을 입력해주세요.');
      return;
    }

    handleConfirm({
      confirmContent: `'${trimmed}' 그룹을 총 ${selected.length.toLocaleString('ko')}명으로 생성하시겠습니까?`,
      yesTitle: '저장',
      confirmNext: async () => {
        try {
          const res = await create({
            name: trimmed,
            userIds: selected.map((u) => u.id),
          });
          toast.success('회원 그룹을 생성했습니다.');
          navigate(`${USER_GROUP_URL}/${res.data.id}`, { replace: true });
        } catch {
          toast.error(DEFAULT_ERROR_MESSAGE);
        }
      },
    });
  };

  return (
    <UiComponent.Box>
      <div css={UserGroupStyle.section}>
        <div css={UserGroupStyle.nameRow}>
          <label htmlFor="user-group-name">그룹명</label>
          <FormComponent.Input
            id="user-group-name"
            value={name}
            maxLength={100}
            placeholder="예: 밭일보틀 출석 완료자"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <Picker selected={selected} onChange={setSelected} />
        <div css={UserGroupStyle.footer}>
          <UiComponent.Button
            variant="border"
            color="primary"
            onClick={() => navigate(USER_GROUP_URL)}
          >
            취소
          </UiComponent.Button>
          <UiComponent.Button
            variant="contained"
            color="primary"
            disabled={isPending}
            onClick={handleSave}
          >
            {`총 ${selected.length.toLocaleString('ko')}명 저장`}
          </UiComponent.Button>
        </div>
      </div>
    </UiComponent.Box>
  );
}

export default Register;
